// @flow

export const toFullUrl = (url: string): string =>
  !/^https?:\/\//i.test(url) ? `https://${url}` : url;
